import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<title>icon-ui-option-delete</title><g fill-rule=\"evenodd\"><path d=\"M15.143 27.143v39.714h41.714V27.143H15.143zM10 22h52v50H10V22z\" fill-rule=\"nonzero\"></path><path d=\"M10 15v7h52v-7H10zm-5-5h62v17H5V10z\" fill-rule=\"nonzero\"></path><path d=\"M31 10h10V5H31v5zM26 0h20v15H26V0z\" fill-rule=\"nonzero\"></path><path d=\"M26 32h5v30h-5zM41 32h5v30h-5z\"></path></g>", 2)
  ]))]))
}
export default { render: render }